<template>
  <div class="grid-box">
    <!-- 页头部分 - start -->
    <div class="header">
      <!-- 加载中组件 -->
      <Spin size="large" fix v-if="isLoading"></Spin>
      <div class="header-top">
        <!-- 切换语言 - start -->
        <div class="lang-wrap" v-if="langTypes.length > 0">
          <a v-for="(lang, index) in langTypes" :key="index"
            :class="{actived: lang.key === $i18n.locale}"
            @click.stop="langChange(lang)"
            href="javascript:;">{{lang.name}}</a>
        </div>
        <!-- 切换语言 - end -->

        <ul :class="['right-menu', { 'en': $i18n.locale !== 'zh' } ]">
          <li v-if='false'>
            <!-- 未登陆 - start -->
            <template v-if="!isLogin">
              <div class="user-info-box">
                <Spin size="large" fix v-if="isLoginLoading"></Spin>
                <a @click.stop="doLogin" href="javascript:;">
                  <!-- 登录 -->
                  {{ $t('system.signin') }}
                </a>
                <a @click.stop="doRegister" href="javascript:;">
                  <!-- 注册 -->
                  {{ $t('system.register') }}
                </a>
                <span>|</span>
              </div>
            </template>
            <!-- 未登陆 - end -->
            <!-- 已登陆 - start -->
            <template v-else>
              <v-poptip trigger="hover" class="global-poptip-user-info poptip-user-info" :width="$i18n.locale === 'zh' ? 80 : 180">
                <span class="user-name" @click="toCenter">
                  <!--您好,-->
                  {{ $t('text.wellcome', { punctuation: ',' }) }}
                  {{ userName }}
                </span>
                <template slot="content">
                  <div class="my-info">
                    <p v-for="menu in my" :key="menu.t">
                      <router-link :to="menu.to">{{ $t(menu.t) }}</router-link>
                    </p>
                    <p @click="signout">
                      <!-- 注销 -->
                      <a href="javascript:void(0);">
                        {{ $t('system.signout') }}
                      </a>
                    </p>
                  </div>
                </template>
              </v-poptip>
            </template>
            <!-- 已登陆 - end -->
          </li>
          <li v-for="nav in smallNavigation" :key="nav.t">
            <template v-if="nav.to">
              <a href="javascript:;" @click.stop="doRoute(nav.to)">
                {{ $t(nav.t) }}
              </a>
            </template>
            <template v-else>
              <!-- 手机订餐 -->
              <v-poptip class="phoneItem" trigger="hover">
                <a href="javascript:;" @click.stop="doRoute(nav.to)" class="phone">
                  {{ $t(nav.t) }}
                </a>
                <!--<template slot="content">
                  <div class="my-phone">
                    <div class="title">
                      {{ $t(nav.t) }}
                    </div>
                    <img :src="$i18n.locale === 'zh' ? qrImgZh: qrImgEn">
                  </div>
                </template>-->
              </v-poptip>
            </template>
            <!--<span v-show="$i18n.locale === 'en' && nav.to !== '/restaurantList'">|</span>-->
          </li>
        </ul>
      </div>
    </div>
    <!-- 页头部分 - end -->
  </div>
</template>

<script>
// import * as Com from "./common";
// import { getThridConfig, turnToRouterByType } from "project/util/thridPartUtil";
import { Poptip } from 'iview';
import settingMixin from '@/mixins/setting';

const qrImgEn = require('../../../src/assets/image/other/QR-en.jpg');
const qrImgZh = require('../../../src/assets/image/other/QR-zh.jpg');

export default {
  name: 'main-header',
  mixins: [
    settingMixin,
  ],
  components: {
    VPoptip: Poptip,
  },
  data() {
    return {
      isLoading: false,
      isLoginLoading: false,
      qrImgEn,
      qrImgZh,
      my: [ // 登录后显示的用户菜单
        {
          t: 'header.user.info', // 我的信息
          to: '/user-center',
        },
        {
          t: 'orders.my', // 我的订单
          to: '/user-center/order',
        },
        {
          t: 'header.user.points', // 我的积分
          to: '/user-center/integral',
        },
        {
          t: 'header.user.coupons', // 我的优惠券
          to: '/user-center/coupon',
        },
      ],
      smallNavigation: [
        // { t: 'header.code', to: '/user-center/coupon' },
        // { t: 'header.about', to: '' }, // /aboutUs
        // { t: 'header.pizza', to: '/pizzaExpert' },
        // { t: 'header.mobile' },
        { t: 'header.papa', to: '' }, // restaurantList
      ],
    };
  },
  created() {
    this.getWebSetting();
  },
  methods: {
    toCoupons() {
      // 跳转到兑换优惠券页面
      this.$router.push('/user-center/coupon');
    },
    toCenter() {
      // 跳转到用户中心
      if (this.$route.path.indexOf('-center') < 0) {
        // 判断当前路由
        this.$router.push('/user-center/order')
          .then(Function.prototype)
          .catch(Function.prototype);
      }
    },
    // 用户点击注销按钮
    signout() {
      // 清除服务端缓存
      this.$service.caches.set({ secretKey: '' })
        .then(() => {
          // 清除服务端缓存成功
          // 清除service.user对象
          // 调用service.user.clear function
          this.$service.user.getUser().clear();
          // 重置值
          this.isLogin = false;
          this.userName = '';
          this.$router.push('/').catch(Function.prototype);
        });
    },
    doLogin() {
      this.$parent.openLoginModal();
      // let self = this;
      // Com.USER.login({
      //   success(result) {
      //     if (Com.$bus) {
      //       Com.$bus.$emit('loginSuccess', result);
      //     }
      //     callback(result);
      //   }
      // });
    },
    doRoute(page) {
      if (page) {
        this.$router.push(page);
      }
    },
    doRegister() {
      this.$router.push('/register');
      // let self = this;
      // Com.USER.register({
      //   success(result) {
      //     self.isLogin = true;
      //     self.userName = result.userName;
      //     if (Com.$bus) {
      //       Com.$bus.$emit('loginSuccess', result);
      //     }
      //   }
      // });
    },
    turnToRouterByType(clickType, pageSign, url) {
      console.log(clickType, pageSign, url);
      // turnToRouterByType(this.$router, clickType, pageSign, url);
    },
    // doLogout() {
    //   let self = this;
    //   Com.user.$logout();
    // },
    langChange(lang) {
      // 餐单页以及结算页切换语言则弹框提示
      this.reloadPage(lang);
      window.location.reload();
      // let self = this;
      // let localLang = window.localStorage.getItem(___PROJECT + '_lang');
      // if(localLang && localLang !== lang.key){
      //   try {
      //     if (this.$children.length && this.$children[0].$children.length && this.$children[0].$children[0].$empty) {
      //       Modal.confirm({
      //         content:购物车将会被清空！',
      //         onOk () {
      //           self.$children[0].$children[0].$empty();
      //           self.reloadPage(lang);
      //         },
      //         onCancel () {
      //           return false;
      //         }});
      //     } else if (this.$children.length && this.$children[0].$children.length && this.$children[0].$children[0].$backToBooking) {
      //       Modal.confirm({
      //         content:购物车将会被清空！',
      //         onOk () {
      //           self.reloadPage(lang);
      //           self.$children[0].$children[0].$backToBooking();
      //         },
      //         onCancel () {
      //           return false;
      //       }});
      //     } else {
      //       this.reloadPage(lang);
      //     }
      //   } catch(err) {
      //     console.log(err)
      //   }
      // } else {
      //   this.reloadPage(lang);
      // }
    },
    reloadPage(lang) {
      // lang: zh/hk/en
      // Com.show();
      this.locale = lang.key;
      this.langType = lang.value;
      this.$i18n.locale = lang.key; // 改变语言环境
      localStorage.setItem('lang', lang.key);
      this.$service.caches.set({ langType: lang.value });
    },
    login() {
      this.isLogin = this.$service.user.getUser().check();
      this.userName = `${this.$service.user.getUser().info.nickName}(${this.$service.user.getUser().third.fdPoints} ${this.$t('system.points')})`;
    },
    checkLogin() {
      // 判断是否已登录
      this.isLoginLoading = true;
      this.$service.user.isLogin()
        .then(() => this.$service.user.getUserInfo())
        // .then((res) => this.$service.user.third.query({ content: { mobile: res.data.phone } }).then((thirdData) => [res, thirdData]))
        .then(() => {
          // 获取用户数据
          // this.isLogin = true;
          // this.$service.user.getUser().login(arg[0].serverTime, arg[0].data, arg[1].data);
          // this.isLogin = this.$service.user.getUser().check();
          // this.userName = this.$service.user.getUser().info.nickName;
          this.login();
          // Com.user && Com.user.$loginSuccess(user);
          // Com.$bus && Com.$bus.$emit('loginSuccess', user);
        })
        .catch((Function.prototype))
        .finally(() => {
          this.isLoginLoading = false;
        });
    },
  },
  mounted() {
    // 检查登录状态
    this.checkLogin();
  },
};
</script>

<style lang="less">
.right-menu {
  .ivu-poptip , .ivu-poptip-rel{
    padding: 0;
    height: 40px;
  }
}
.phoneItem {
  .phone{
    color: #333;
    padding-right: 8px;
  }
  .my-phone {
    background: url('../../../src/assets/image/other/mobile-bg.png') no-repeat;
    padding: 0;
    height: 160px;
    position: relative;
    img {
      width: 115px;
      position: absolute;
      bottom: 6px;
      left: 5px;
    }
    .title {
      position: absolute;
      font-size: 16px;
      left: 44px;
      top: 12px;
    }
  }
  .ivu-poptip-popper {
    min-width: 120px;
    width: 125px;
  }
  .ivu-poptip-body {
    padding: 0 !important;
  }
}
</style>
<style lang="sass" scoped>
@import '../../assets/css/mixins'

.grid-box
  font-size: 14px
  position: relative
  min-height: 100%
  _height: 100%
  .header,
  .main-wrap
    @include base-wrap
.header-top
  height: 52px
  width: 100%
  background-color: #fff
  display: flex
  justify-content: space-between
  .lang-wrap
    padding-left: 166px
    line-height: 52px
    a
      font-size: 12px
      color: #333
      &.actived, &:hover
        color: #0f9675
      &:not(:first-child):before
        text-align: center
        content: '|'
        display: inline-block
        width: 13px
        color: #333
        &:hover
          color: #333
  .right-menu
    overflow: hidden
    &.en
      font-size: 12px
    >li
      line-height: 52px
      padding-right: 8px
      float: left
      height: 100%
      .user-info-box
        position: relative
        >a
          color: #333
          padding-right: 5px
          &:hover
            color: #0f9675
      .poptip-user-info
        height: 35px
      .user-name
        padding-top: 17px
        cursor: pointer
        overflow: hidden
        white-space: nowrap
        text-overflow: ellipsis
        max-width: 200px
        line-height: normal
        display: inline-block
      .my-info
        text-align: center
        p
          color: #414141
          line-height: 32px
          font-size: 14px
          cursor: pointer
          &:hover
            color: #fff
            background-color: #149270
          a
            display: inline-block
            color: inherit
            width: 100%
            &:hover
              color: #fff
      >a
        color: #333
        padding-right: 5px
        &:hover
          color: #0f9675
  .logined-wrap
    .hello-tip, .user__btn
      color: #7a7a7a
    .hello-tip
      float: left
      max-width: 278px
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .user__btn
      float: left
      padding-left: 20px
      font-size: 14px
.header-nav
  @include base-wrap
  @include border-radius(8px)
  height: 80px
  background-color: #f28329
  overflow: hidden
  .logo-box
    max-width: 420px
    height: 80px
    overflow: hidden
    a
      margin-top: 11px
      display: inline-block
      &.brand-skip:first-child
        margin-left: 40px
        margin-right: 0px
      &.brand-skip
        margin-left: 15px
      &.wm-skip
        margin-right: 5px
      img
        height: 58px
        line-height: 58px
  .nav-box
    height: 80px
    .nav-list
      li
        display: inline-block
        min-width: 218px
        height: 30px
        line-height: 30px
        margin-top: 25px
        border-left-color: transparent
        &:not(:first-child)
          border-left: 1px solid #fff
        i[class^='icon-']
          display: block
          float: left
          width: 32px
          height: 32px
          margin: -2px 10px 0 46px
          // @include bg-url('~static/images/candao-web-v6/my_icon.png')
          @include bg-repeat
          @include bg-position(-15px 0px)
          &.icon-order-page
           @include bg-position(-15px 0px)
          &.icon-my-account
           @include bg-position(-15px -33px)
          &.icon-help-page
           @include bg-position(-15px -65px)
        a
          font-size: 20px
          color: #fff
          padding-right: 15px
</style>
